import React, { useState } from "react";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { defaultValueSearch } from "./headers";
import { styleEndowment } from "./styleEndowment";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import utils from "../../utils/utils";
import { useStateValue } from "../../context/store";

const SearchEndowment = ({ maestras, regionals }) => {
  const classes = styleEndowment();
  const [{}, dispatch] = useStateValue();
  const soloLetras = /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g;
  var currentDate = new Date();
  const [minDate, setMinDate] = useState(null);
  const [maxInitDate, setMaxInitDate] = useState(
    utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(soloLetras, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    surname: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(soloLetras, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    documentType: yup.string().nullable().notRequired(),
    document: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(16, "Ingrese máximo 16 caracteres")
      //.matches(/^([0-9]{0,16})$/, "Ingrese un número de identificación válido")
      .transform((v) => (v ? v : null)),
    regional: yup.string().nullable().notRequired(),
    deliverDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (deliverDate) => deliverDate && deliverDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    initDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (initDate) => initDate && initDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    endDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (endDate) => endDate && endDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm: defaultValueSearch,
    mode: "all",
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    if (
      data.firstName !== null ||
      data.surname !== null ||
      data.documentType !== null ||
      data.document !== null ||
      data.regional !== null ||
      data.deliverDate !== null ||
      data.initDate !== null ||
      data.endDate !== null
    ) {
      dispatch({
        type: "SET_FILTER_ENDOWMENT",
        filter: data,
        isFilter: true,
      });
    }
  };

  const handleUserKeyPressDocumento = (e) => {
    var form = getValues();
    if (form.documentType !== "PP" && form.documentType !== "CE") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const cleanFilter = () => {
    dispatch({
      type: "SET_FILTER_ENDOWMENT",
      filter: {
        firstName: null,
        surname: null,
        documentType: null,
        document: null,
        regional: null,
        deliverDate: null,
        initDate: null,
        endDate: null,
      },
      isFilter: true,
    });
  };

  const cleanForm = () => {
    cleanFilter();
    setValue("firstName", "");
    setValue("surname", "");
    setValue("documentType", "");
    setValue("document", "");
    setValue("regional", "");
    setValue("deliverDate", null);
    setValue("initDate", null);
    setValue("endDate", null);
    setMaxInitDate(new Date());
    setMinDate(null);
  };

  const onChangeDate = (value) => {
    setMinDate(value);
  };

  const validateMaxInitDate = () => {
    var currentData = getValues();
    if (!currentData.endDate) {
      setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
    } else {
      setMaxInitDate(utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
    }
  };

  const updateMaxInitDate = (date) => {
    var currentData = getValues();
    if (!currentData.initDate) {
      setMaxInitDate(date);
    } else {
      setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
    }
  };

  return (
    <div className={classes.divSearch}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                type="text"
                name="firstName"
                label="Primer nombre"
                variant="outlined"
                size="small"
                inputRef={register}
                fullWidth
                className={classes.inputForm}
                error={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                type="text"
                name="surname"
                label="Primer apellido"
                variant="outlined"
                size="small"
                inputRef={register}
                fullWidth
                className={classes.inputForm}
                error={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("surname") && errors["surname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de documento
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="documentType"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Tipo de documento"
                size="small"
                notched={true}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {maestras?.tipoDocumnetoIdentificacion?.map((res) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={res?.key}
                        value={res?.key}
                      >
                        {res?.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="text"
                name="document"
                defaultValue=""
                className={classes.inputForm}
                label="Número Documento"
                variant="outlined"
                fullWidth
                size="small"
                error={
                  errors.hasOwnProperty("document") &&
                  errors["document"].message
                }
                onKeyPress={handleUserKeyPressDocumento}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("document") &&
                  errors["document"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("regional") &&
                errors["regional"].message
              }
            >
              <InputLabel htmlFor="outlined-select-regional" shrink={true}>
                Regional
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="regional"
                inputRef={register}
                defaultValue=""
                className={classes.inputForm}
                label="Regional"
                size="small"
                notched={true}
                inputProps={{
                  name: "regional",
                  id: "outlined-select-regional",
                }}
                as={
                  <Select>
                    {regionals?.map((res) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={res?.id}
                        value={res?.id}
                      >
                        {res?.name}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("regional") &&
                  errors["regional"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                control={control}
                name="deliverDate"
                placeholder="dd/mm/yyyy"
                size="small"
                defaultValue={null}
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputRef={register}
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    dateFormat="DD/MM/YYYY"
                    className={classes.inputForm}
                    label="Fecha de entrega"
                    InputLabelProps={{ shrink: true }}
                    error={
                      !!errors.hasOwnProperty("deliverDate") &&
                      errors["deliverDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("deliverDate") &&
                      errors["deliverDate"].message
                    }
                    minDate={"01.01.1900"}
                    minDateMessage={"No puede ser menor a la fecha actual"}
                  />
                }
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} md={2} lg={2}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    className={classes.inputForm}
                    dateFormat="DD/MM/YYYY"
                    label="Desde"
                    InputLabelProps={{ shrink: true }}
                    onAccept={onChangeDate}
                    onOpen={validateMaxInitDate}
                    error={
                      !!errors.hasOwnProperty("initDate") &&
                      errors["initDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("initDate") &&
                      errors["initDate"].message
                    }
                    minDate="01.01.2020"
                    //maxDate={maxInitDate}
                  />
                }
                control={control}
                name="initDate"
                defaultValue={null}
                placeholder="Desde"
                size="small"
              />
            </MuiPickersUtilsProvider>
            <FormHelperText style={{ color: "#f44336" }}></FormHelperText>
          </Grid>

          <Grid item xs={12} md={2} lg={2}>
            <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
              <Controller
                as={
                  <KeyboardDatePicker
                    fullWidth
                    inputVariant="outlined"
                    variant="inline"
                    format="dd/MM/yyyy"
                    dateFormat="DD/MM/YYYY"
                    className={classes.inputForm}
                    label="Hasta"
                    InputLabelProps={{ shrink: true }}
                    onAccept={updateMaxInitDate}
                    error={
                      !!errors.hasOwnProperty("endDate") &&
                      errors["endDate"].message
                    }
                    helperText={
                      errors.hasOwnProperty("endDate") &&
                      errors["endDate"].message
                    }
                    minDate={minDate ? minDate : "01.01.2020"}
                    //maxDate={maxDate}
                  />
                }
                control={control}
                name="endDate"
                defaultValue={null}
                placeholder="Hasta"
                size="small"
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} md={2} lg={2}>
            <Button
              type="submit"
              variant="contained"
              className={classes.buttonSearch}
            >
              Buscar
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              onClick={cleanForm}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default SearchEndowment;
